$(document).ready(function() {
    // var vendorlink = "/blogs/vendor/artisan-box";
    var vendorlink = $('.about_the_vendor_wrap .vendor_blog_post_detail').attr('data-link');
    //console.log('vendorlink => ', vendorlink);
var parts = vendorlink.split('/blogs');
    var baseUrl = parts[0];
    var blogPath = '/blogs' + parts[1];

    console.log('Base URL:', baseUrl);
    console.log('Blog Path:', blogPath);

    $.ajax({
        type: "GET",
        url: blogPath,
        dataType: "html",
        success: function(data) {
            // Create a temporary DOM element to hold the fetched HTML
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            // Find the specific element inside the temporary DOM
            var specificContent = $(tempDiv).find('.meta_richtext_cont').html();

            // Update the content of your actual .meta_richtext_cont element
            $('.meta_richtext_cont').html(specificContent);
            //console.log('specificContent', specificContent);
            $('.vendor_blog_post_detail').append(specificContent);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('AJAX error:', textStatus, errorThrown);
            //alert('Error: ' + jqXHR.status + ' ' + errorThrown);
        }
    });
  setTimeout(function(){
  var datalenth = $('.vendor_blog_post_detail .metafield-rich_text_field').length;
  if(datalenth == 0 ){
    $('.about_the_vendor_wrap').hide();
  } 
  },5000);

});
